import { IsBoolean, IsDefined, IsInt, IsNotEmpty, IsOptional, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '../../constants';
import { BaseDto } from '../base.dto';
import { CostCentreDto } from '../costCentre.dto';

export class FinanceHouseAccountDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantGroupId: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 45)
  @Matches(validationPatterns.noteValidation)
  name: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsInt()
  @IsOptional()
  entityId: number;

  @IsOptional()
  nominalCode: string;

  @IsOptional()
  accountsReference: string;

  @IsOptional()
  creditTerms: number;

  @IsOptional()
  creditLimit: number;

  @IsOptional()
  tag: string;

  @IsOptional()
  poc1name: string;

  @IsOptional()
  poc1phoneNumber: string;

  @IsOptional()
  poc1email: string;

  @IsOptional()
  poc1address: string;

  @IsOptional()
  poc2name: string;

  @IsOptional()
  poc2phoneNumber: string;

  @IsOptional()
  poc2email: string;

  @IsOptional()
  poc2address: string;

  @IsOptional()
  poc3name: string;

  @IsOptional()
  poc3phoneNumber: string;

  @IsOptional()
  poc3email: string;

  @IsOptional()
  poc3address: string;

  @IsOptional()
  costCentres: CostCentreDto[];
}
